export default "__VITE_ASSET__HlEvG7Vp__"